import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IFeedbackTransaction } from '../builders/plan_feedback_transaction_builder';
import { planFeedbackTransactionActionType } from '../builders/plan_feedback_transaction_type';
import { IPlanFeebackCourseGroupsDatasource } from '../datasources/plan_feedback_course_groups_datasource';
import { IPlanFeebackCoursesDatasource } from '../datasources/plan_feedback_courses_datasource';
import { IPlanFeedbackProgramSlotsDatasource } from '../datasources/plan_feedback_program_slots_datasource';
import { APPlanFeedbackDataSourceUpdateAfterAcceptDeclineStrategy } from '../strategies/plan_feedback_transaction_types_query_strategy';
import { PlanFeedbackServant } from './../servants/plan_feedback_servant';

angular
  .module('capability-ng-academic-planner')
  .service(
    'acceptDeclinePlanFeedbacksCommand',
    function acceptDeclinePlanFeedbacksCommand(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngPlanFeebackCoursesDatasource: IPlanFeebackCoursesDatasource,
      ngPlanFeedbackProgramSlotsDatasource: IPlanFeedbackProgramSlotsDatasource,
      ngPlanFeebackCourseGroupsDatasource: IPlanFeebackCourseGroupsDatasource
    ) {
      return defineCommandORM(
        'acceptDeclinePlanFeedbacksCommand',
        (
          deferred: any,
          suggestedPlanId: number,
          feedbacks: IFeedbackTransaction[],
          action: planFeedbackTransactionActionType
        ) => {
          const apiParams = _4.map(_4.uniqBy(feedbacks, 'resolution'), (feedback) => ({
            resolution: feedback.resolution,
            action
          }));

          $http
            .post(`/academicplan/suggested_plan_resolution/${suggestedPlanId}/resolve_transaction/`, apiParams)
            .then((response) => {
              const resolutions = _4.uniq(_4.map(feedbacks, (feedback) => feedback.resolution));
              PlanFeedbackServant.updateDataSourcesAfterAcceptDecline(
                ngPlanFeebackCoursesDatasource,
                action,
                resolutions
              );
              PlanFeedbackServant.updateDataSourcesAfterAcceptDecline(
                ngPlanFeebackCourseGroupsDatasource,
                action,
                resolutions
              );
              PlanFeedbackServant.updateDataSourcesAfterAcceptDecline(
                ngPlanFeedbackProgramSlotsDatasource,
                action,
                resolutions
              );
              deferred.resolve();
            })
            .catch((error) => {
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/commands/accept_decline_plan_feedback_command.ts